import { push, replace } from 'connected-react-router';

import { fulfillmentOptions } from 'cart/constants/fulfillmentOptions';
import { closeModal } from 'base/actions/modal';
import { generatePath } from 'utils/generatePath';
import { editLocationInCart } from 'cart/actions';
import { openNotificationModal } from 'base/actions/notificationModals';
import { CHANGE_LOCATION } from 'cart/constants/notificationTypes';
import { resetIsCartItemAvailable } from 'cart/actions/cartAvailable';

import { getSoleEntity } from 'base/reducers/bentoApi';
import { MENU } from 'menus/constants/entities';

import { translateAddressFromComponents } from 'base/utils/addressHelpers';
import { setCartWorkingCopy } from 'cart/actions/cartWorkingCopy';
import {
  validateAddressInDeliveryZone,
  setCartAddressAndGetLocationsInRelation
} from 'locations/actions/dinerAddressDeliverable';
import handleSingleLocationFlow from 'base/actions/handleSingleLocationFlow';

export const selectLocation = (
  id,
  fulfillmentMethod = fulfillmentOptions.PICKUP
) => async dispatch => {
  const result = await dispatch(
    editLocationInCart({
      online_ordering_location: id,
      online_ordering_fulfillment_method: fulfillmentMethod
    })
  );
  dispatch(handleSingleLocationFlow(result.payload));
};

export const selectLocationWithValidation = (id, fulfillmentMethod) => (
  dispatch,
  getState
) => {
  const state = getState();

  const cannotFulfill =
    state.cart.online_ordering_location &&
    state.cart.online_ordering_location !== id &&
    !!state.cart.items.length;
  if (cannotFulfill) {
    return dispatch(
      openNotificationModal(CHANGE_LOCATION, {
        onlineOrderingLocation: id
      })
    );
  }
  dispatch(selectLocation(id, fulfillmentMethod));
};

/**
 * Action to close location detail modal by clicking the x,
 * clicking on darkened area, and route. It executes the callback
 * to determine the route to return to. This works for both
 * LocationDetail and OrderSetting
 */
export const closeLocationDetailModal = returnToCallback => dispatch => {
  dispatch(closeModal());

  dispatch(resetIsCartItemAvailable());
  returnToCallback();
};

export const goToMenuViaSlug = (slug, historyMethod = push) => dispatch => {
  dispatch(historyMethod(generatePath(MENU, 'menu', { slug })));
};

export const goToMenuForSingleLocation = () => (dispatch, getState) => {
  const { restaurantLocations } = getState();
  const location = getSoleEntity(restaurantLocations);
  const slug = location.location.slug;
  dispatch(goToMenuViaSlug(slug, replace));
};

export const goToOrderSettingsViaSlug = (
  slug,
  historyMethod = push
) => dispatch => {
  dispatch(
    historyMethod(
      generatePath(MENU, 'orderSetting', {
        slug
      })
    )
  );
};

export const goToOrderSettingsForSingleLocation = () => (
  dispatch,
  getState
) => {
  const { restaurantLocations } = getState();
  const location = getSoleEntity(restaurantLocations);
  const slug = location.location.slug;
  dispatch(goToOrderSettingsViaSlug(slug, replace));
};

export const handleAddressSelect = (address, placeId) => dispatch => {
  const parsedAddress = translateAddressFromComponents(address, placeId);
  dispatch(setCartWorkingCopy(parsedAddress));
  dispatch(validateAddressInDeliveryZone(parsedAddress));
};

export const handleAddressSelectLocationList = (
  address,
  placeId
) => dispatch => {
  const parsedAddress = translateAddressFromComponents(address, placeId);
  dispatch(setCartAddressAndGetLocationsInRelation(parsedAddress));
};
